import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  fullWidthContainer: {
    width: '100%',
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  generalText: {
    color: theme.palette.labraText.description,
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
  },
  upperWrapper: {
    marginBottom: theme.spacing(5),
  },
  sectionHeading: {
    color: theme.palette.labraText.primary,
    fontSize: theme.spacing(2.25),
    fontWeight: 400,
    lineHeight: theme.spacing(3.5),
    paddingBottom: theme.spacing(2),
    width: '98%',
  },
  value: {
    color: theme.palette.labraText.description,
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    paddingBottom: theme.spacing(2),
  },
  pricingSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  pricingModelLabelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  pricingModelTitle: {
    height: theme.spacing(3),
    width: theme.spacing(14.125),
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: theme.spacing(2),
    letterSpacing: '0.15px',
    color: theme.palette.shadows.dark,
    lineHeight: theme.spacing(3),
  },
  pricingModelInfoIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    fontSize: theme.spacing(2),
    color: theme.palette.shadows.light,
    cursor: 'pointer',
  },
  pricingDividerContainer: {
    width: 'auto',
    height: theme.spacing(0.125),
    borderRadius: theme.spacing(0.5),
    justifyContent: 'space-between',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
}))
